import type { ResultItem } from "@/types/resultItem";
import type EcommerceItem from "@/types/ecommerceItem";
import {
  ITEM_LIST_ID,
  ITEM_LIST_NAME,
} from "@/globalConsts/searchFunnelEvents";

export default function createEcommerceItem(
  resultItem: ResultItem,
  index: number
): EcommerceItem {
  return {
    affiliation: "",
    coupon: "",
    currency: resultItem.currency,
    discount: 0,
    index: index,
    item_brand: resultItem.organizerName,
    item_category: resultItem.tripType,
    item_category2: "",
    item_category3: resultItem.highlightTags.join("/"),
    item_category4: resultItem.countryNames.join("/"),
    item_category5: "",
    item_id: resultItem.uid,
    item_list_id: ITEM_LIST_ID,
    item_list_name: ITEM_LIST_NAME,
    item_name: resultItem.title,
    item_variant: "",
    location_id: "",
    price: resultItem.price,
    quantity: 1,
  } as EcommerceItem;
}
